import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

import { useLocation, useNavigate } from "react-router"
import { Secure } from "lib/authorization/secure"
import { Frag } from "lib/@components/slot/frag"
import { AUTHORING_MANAGE_WORK_PACKAGE_USERS_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"

export function ProjectAccessButton() {
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <Secure demand={AUTHORING_MANAGE_WORK_PACKAGE_USERS_DEMAND} fallback={<Frag />}>
            <AccessButton onClick={handleClick} />
        </Secure>
    )

    function handleClick() {
        // Ensure no double slash
        let target = location.pathname.endsWith("/") ? location.pathname + "users" : location.pathname + "/users"
        navigate(target)
    }
}

function AccessButton({ onClick }) {
    return (
        <Button
            onClick={onClick}
            sx={{ color: "primary.main" }}
            startIcon={<Iconify icon="ic:round-person" />}
            data-cy="regime-access-button"
        >
            User Access
        </Button>
    )
}
